import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useAestheticProcedureActions(baseUrl) {
  const [isLoading, setLoading] = useState(false);

  const finish = useCallback(
    (procedureId) => {
      setLoading(true);
      return quarkusApi
        .put(`${baseUrl}/${procedureId}/finish`, {}, authHeader())
        .finally(() => setLoading(false));
    },
    [baseUrl],
  );

  const remove = useCallback(
    (procedureId) => {
      setLoading(true);
      return quarkusApi
        .delete(`${baseUrl}/${procedureId}`, authHeader())
        .finally(() => setLoading(false));
    },
    [baseUrl],
  );

  return { finish, remove, isLoading };
}
